<template>
  <div class="container">
    <img src="./assets/logo.png" alt="PlantGame 2021" class="logo" />
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  created() {
    this.fetchPlants();
  },
  methods: {
    ...mapActions({
      fetchPlants: "fetchPlants",
    }),
  },
};
</script>